import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import set from 'lodash/set';

export default function nestedObject(obj) {
    if (!isPlainObject(obj)) return obj;
    return Object.keys(obj).reduce((result, key) => {
        const value = obj[key];
        const path = key.replace(/Id/g, '');
        set(result, path, isArray(value) ? value[0] : value);
        return result;
    }, {});
}
